export class AssinantesModel {
  id_assinante: number = 0;
  id_usuario: number = 0;
  cgc_mapa: string;
  senha: string;
  com_certificado: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes.model.ts